import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import DesktopHeader from '../desktop/DesktopHeader';
import DesktopMenuBar from '../desktop/DesktopMenuBar';
import DesktopFooter from '../desktop/DesktopFooter';
import '../../styles/desktop-homepage-replica.css';

const STATIC_PAGES = [
  { path: '/about', label: 'About' },
  { path: '/safety', label: 'Safety' },
  { path: '/community-guidelines', label: 'Guidelines' },
  { path: '/faq', label: 'FAQ' },
  { path: '/terms', label: 'Terms' },
  { path: '/privacy', label: 'Privacy' },
];

const DesktopShell = ({ children, showHeader = true, showMenuBar = true, mainClassName = '' }) => {
  const location = useLocation();
  const pathname = location?.pathname || '/';
  const currentStatic = STATIC_PAGES.find((page) => pathname.startsWith(page.path));

  return (
    <div className="desktop-replica desktop-replica--glass" data-desktop-shell="true">
      {showHeader && (
        <div className="dr-header-wrapper">
          <DesktopHeader />
        </div>
      )}
      {showMenuBar && !currentStatic && <DesktopMenuBar />}
      {currentStatic && (
        <div className="dr-static-breadcrumb">
          <div className="dr-static-breadcrumb__inner">
            <div className="dr-static-breadcrumb__trail">
              <Link to="/" className="dr-static-breadcrumb__home">Home</Link>
              <span className="dr-static-breadcrumb__sep">/</span>
              <span className="dr-static-breadcrumb__current">{currentStatic.label}</span>
            </div>
            <div className="dr-static-breadcrumb__links">
              {STATIC_PAGES.map((page) => (
                <Link
                  key={page.path}
                  to={page.path}
                  className={`dr-static-breadcrumb__link ${page.path === currentStatic.path ? 'dr-static-breadcrumb__link--active' : ''}`}
                >
                  {page.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
      <main className={`desktop-replica__main ${mainClassName}`.trim()}>
        {children}
      </main>
      <DesktopFooter />
    </div>
  );
};

export default DesktopShell;
